// extracted by mini-css-extract-plugin
module.exports = {"formProyect":"styles_formProyect___5QcW","headerForm":"styles_headerForm__7jrx7","buttonContainer":"styles_buttonContainer__3ewY_"};